import React from 'react';
import Button from "../../../components/ui/button/button";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";
import TextField from "../../../components/TextField/TextField";
import API from "../../../components/api";
import {SERVER_URL} from "../../../config";
import ImageUploader from "../../../components/ui/imageUploader/imageUploader";


class AdminPanelBannerPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],

            tabValues: [
                {name: 'На главной странице', value: true},
                {name: 'Только в списке всех вопросов', value: false},
            ],
        }

        this.changeItem = (name, index, value) => {
            let {items} = this.state;

            items[index][value] = name

            this.setState({
                items: [...items]
            });
        }

        this.addItem = () => {
            const {items} = this.state;

            let item = {
                id: -Math.random(),
                name: '',
                document_url: '',
                order: 0
            }

            this.setState({
                items: [item, ...items]
            });
        }

        this.updateItems = () => {
            API.adminGetBanner()
                .then(data => this.setState({items: [data]}))
                .catch(error => {
                })
        }

        this.saveItems = (items) => {
            API.adminSaveBanner(items[0])
                .then(data => {
                    this.props.addSnackbar("Вопросы успешно сохранены", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить вопросы", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.swapItem = (itemId, side) => {
            const {items} = this.state;

            const index = items.findIndex(c => c.id === itemId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= items.length) {
                return;
            }

            const current = items[index];
            items[index] = items[targetIndex];
            items[targetIndex] = current;

            this.setState({items: items})
        }

        this.deleteItem = (itemId) => {
            this.setState(prevState => {
                const items = prevState.items;
                const newItems = items.filter(s => s.id !== itemId);

                return {
                    items: newItems
                };
            });
        };
    }

    componentDidMount() {
        this.updateItems()
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <div className='title'>
                    Баннер на главной
                </div>
                <div className='controls'>
                    <Button type='accent' size='medium' onClick={() => {
                        this.saveItems(this.state.items)
                    }}>
                        Сохранить изменения
                    </Button>
                    <Button type='primary' size='medium'
                            onClick={() => {
                                this.updateItems()
                            }}>
                        Отменить
                    </Button>
                </div>
            </div>
            <div className='content'>
                <div className='items'>
                    {
                        this.state.items.map((item, index) => {
                            return <div key={item.id} className='item'>
                                <TextField label='Заголовок' fullWidth
                                           value={this.state.items[index].title}
                                           onChange={(e) => this.changeItem(e.target.value, index, 'title')}/>
                                <TextField label='Название кнопки' fullWidth
                                           value={this.state.items[index].button_text}
                                           onChange={(e) => this.changeItem(e.target.value, index, 'button_text')}/>
                                <TextField label='Ссылка, куда ведёт кнопка' fullWidth
                                           value={this.state.items[index].button_link}
                                           onChange={(e) => this.changeItem(e.target.value, index, 'button_link')}/>
                                <ImageUploader description='От 604 х 672, форматы jpeg, png' size='small'
                                               imageBase64={this.state.items[index].image_base64}
                                               url={this.state.items[index].image ? SERVER_URL + this.state.items[index].image : null}
                                               uploadHandler={(b64) => this.changeItem(b64, index, 'image_base64')}/>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelBannerPage);
